import { createFeature, createReducer, on } from '@ngrx/store';

import * as TGAVarietiesActions from './tga-varieties.actions';
import { CropVariety, VarietyPropertiesTGAResponse } from '../models/tga-varieties.model';

export interface TGAVarietiesState {
  varietyProperties: VarietyPropertiesTGAResponse[];
  cropVarieties: CropVariety[];
  loading: boolean;
  error: string | null;
}

export const initialState: TGAVarietiesState = {
  varietyProperties: [],
  cropVarieties: [],
  loading: false,
  error: null,
};

export const tgaVarietiesFeature = createFeature({
  name: 'tgaVarieties',
  reducer: createReducer(
    initialState,
    on(TGAVarietiesActions.loadTGAVarietyPropertiesRequest, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(TGAVarietiesActions.loadTGAVarietyPropertiesSuccess, (state, { varietyProperties }) => ({
      ...state,
      varietyProperties,
      loading: false,
      error: null,
    })),
    on(TGAVarietiesActions.loadTGAVarietyPropertiesFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),
    on(TGAVarietiesActions.upsertTGAVarietyPropertyRequest, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(TGAVarietiesActions.upsertTGAVarietyPropertySuccess, (state, { varietyProperty }) => ({
      ...state,
      varietyProperties: state.varietyProperties.some((vp) => vp.id === varietyProperty.id)
        ? state.varietyProperties.map((vp) => (vp.id === varietyProperty.id ? { ...vp, ...varietyProperty } : vp))
        : [...state.varietyProperties, varietyProperty as VarietyPropertiesTGAResponse],
      loading: false,
      error: null,
    })),
    on(TGAVarietiesActions.upsertTGAVarietyPropertyFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),
    on(TGAVarietiesActions.deleteTGAVarietyPropertyRequest, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(TGAVarietiesActions.deleteTGAVarietyPropertySuccess, (state) => ({
      ...state,
      varietyProperties: state.varietyProperties,
      loading: false,
      error: null,
    })),
    on(TGAVarietiesActions.deleteTGAVarietyPropertyFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),
    on(TGAVarietiesActions.loadCropVarietiesRequest, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(TGAVarietiesActions.loadCropVarietiesSuccess, (state) => ({
      ...state,
      loading: false,
      error: null,
    })),
    on(TGAVarietiesActions.loadCropVarietiesFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),
    on(TGAVarietiesActions.loadProductionPurposeCategoriesRequest, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(TGAVarietiesActions.loadProductionPurposeCategoriesSuccess, (state) => ({
      ...state,
      loading: false,
      error: null,
    })),
    on(TGAVarietiesActions.loadProductionPurposeCategoriesFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),
    on(TGAVarietiesActions.loadCropVarietiesSuccess, (state, { cropVarieties }) => ({
      ...state,
      cropVarieties,
      loading: false,
      error: null,
    })),
  ),
});

export const { selectVarietyProperties, selectLoading, selectError } = tgaVarietiesFeature;
